<template>
  <div class="container mx-auto h-auto laptop:h-almostscreen flex-col flex md:justify-between laptop:justify-center laptop:min-700 min-h-0 relative">
    <div class="z-20 p-1 px-5 sm:p-8 laptop:px-24 laptop:p-0">
      <!-- laptop:ml-12 -->
      <MARSHeading>
        <slot name="title" />
      </MARSHeading>
      <slot name="cta" />
    </div>
    <div class="w-full sm:ml-8 laptop:px-24 laptop:absolute laptop:right-0 laptop:w-3/5 flex xl:content-end xl:justify-end">
      <div>
        <picture>
          <source v-if="imageUrlRightWebp" type="image/webp" :srcset="imageUrlRightWebp">
          <source v-if="imageUrlRightJpeg" type="image/jpeg" :srcset="imageUrlRightJpeg">
          <source v-if="imageUrlRightPng" type="image/png" :srcset="imageUrlRightPng">
          <img class="hidden xl:block laptop:max-500 fullhd:max-700 move-right" style="height:auto !important;" :alt="alt">
        </picture>
      </div>
      <picture>
        <source v-if="imageUrlBelowWebp" type="image/webp" :srcset="imageUrlBelowWebp">
        <source v-if="imageUrlBelowJpeg" type="image/jpeg" :srcset="imageUrlBelowJpeg">
        <source v-if="imageUrlBelowPng" type="image/png" :srcset="imageUrlRightPng">
        <img class="block xl:hidden mt-8 max-h-300 sm:max-500" style="width:auto !important;align-self: flex-start;" :alt="alt">
      </picture>
    </div>
    <div v-if="scrollIndicator" class="w-16 h-16 hidden laptop:block absolute bottom-0 mb-6 left-1/2 -ml-8 z-20">
      <img class="mx-auto" src="~/assets/img/scroll-down-gif.gif" alt="Scroll down indicator">
    </div>
  </div>
</template>

<script lang="ts">
import MARSHeading from '@/components/MARSHeading.vue'
export default defineNuxtComponent({
  name: 'Block01',
  components: { MARSHeading },
  props: {
    imageUrlRightWebp: { type: String, default: null },
    imageUrlRightJpeg: { type: String, default: null },
    imageUrlRightPng: { type: String, default: null },
    imageUrlBelowWebp: { type: String, default: null },
    imageUrlBelowJpeg: { type: String, default: null },
    imageUrlBelowPng: { type: String, default: null },
    scrollIndicator: { type: Boolean, default: false },
    alt: { type: String, default: '' },
  }
})
</script>

  <style scoped>

  @media (min-width: 1600px) {
    .move-right {
      transform:translateX(10%);
    }
  }

  </style>
